import { Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

/**
 * wrapper component to display prejected content in a sidepanel
 * which opens as an overlay
 */
@Component( {
    selector: 'riege-sidepanel',
    standalone: true,
    imports: [MatIconModule, MatButtonModule, MatDialogClose],
    templateUrl: './sidepanel.component.html',
    styleUrl: './sidepanel.component.scss',
    encapsulation: ViewEncapsulation.None
} )
export class SidepanelComponent { }
